import UserRepository from '../../repositories/UserRepository'

const state = {
  users: [],
  user: {},
  error: '',
  listShop: [],
  listCheckin: []
}

const getters = {
}

const actions = {
  async get({ commit }) {
    await UserRepository.get()
      .then(resp => {
        commit('setUsers', resp.data.data)
      })
  },
  async listShop({ commit }) {
    await UserRepository.listShop()
      .then(resp => {
        commit('setListShops', resp.data.data)
      })
  },
  async detail({ commit }, id){
    await UserRepository.detail(id)
      .then(resp => {
        commit('setUser', resp.data.data)
      })
  },
  async put({ commit, dispatch }, payload){
    await UserRepository.put(payload)
      .then(() => {
        commit('setError', '')
        dispatch('get')
      })
  },
  async post({ commit, dispatch }, payload){
    await UserRepository.post(payload)
      .then(() => {
        commit('setError', '')
        dispatch('get')
      }).catch(error => {
        commit('setError', error.response.data.message)
      })
  },
  async delete({ commit, dispatch }, id){
    await UserRepository.delete(id)
      .then(() => {
        commit('setError', '')
        dispatch('get')
      })
  },
  setError({ commit }){
    commit('setError', '')
  },
  async listCheckin({ commit }) {
    await UserRepository.listCheckin()
      .then(resp => {
        commit('setListCheckins', resp.data.data)
      })
  },
}

const mutations = {
  setUsers (state, data) {
    state.users = data
  },
  setListShops (state, data) {
    state.listShop = data
  },
  setUser (state, data) {
    state.product = data
  },
  setCategories (state, data) {
    state.categories = data
  },
  setError(state, msg){
    state.error = msg
  },
  setListCheckins (state, data) {
    state.listCheckin = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
